import { Spin } from 'antd';
import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Environment } from 'relay-runtime';

import { transformData } from '../gantTransformData';
import useAfterLoader from '../hooks/useAfterLoader';
import { SmxGlobalFilterContext } from '../providers/globalFilterProvider';
import { useSharedUrlParams } from '../routing/useSharedUrlParams';
import { RootState } from '../store';
import { LoaderDataType, ScheduleItemType } from '../types';
import Gant from './gant';

export interface IGantWrapper {
    paddingBottom?: number;
    environment?: Environment;
    newItem?: ScheduleItemType;
    isEditable?: boolean;
    authorId: string;
    mode: 'chart' | 'table';
}

const GantWrapper: React.FC<IGantWrapper> = ({ ...restProps }) => {
    const { filterProject } = useContext(SmxGlobalFilterContext);
    useAfterLoader();
    useSharedUrlParams();

    const dataScheduleItemFromServer = useSelector<RootState, LoaderDataType<ScheduleItemType>>(
        (state) => state.gantLoader.dataScheduleItemFromServer,
    );

    const newItems = useMemo(
        () => (filterProject?.length ? transformData(dataScheduleItemFromServer.rows) : []),
        [dataScheduleItemFromServer.rows, filterProject],
    );

    return (
        <Spin tip={'Loading...'} spinning={!dataScheduleItemFromServer.connectionId && !!filterProject?.length}>
            <Gant inputItems={newItems} {...restProps} />
        </Spin>
    );
};

export default GantWrapper;
